export default "__VITE_PUBLIC_ASSET__2ce4509f__"